import Icon from '../components/Icon.vue'

Icon.register({"angle-right":{"width":256,"height":512,"paths":[{"d":"M224.3 273L88.3 409C78.9 418.4 63.7 418.4 54.4 409L31.8 386.4C22.4 377 22.4 361.8 31.8 352.5L128.2 256.1 31.8 159.7C22.4 150.3 22.4 135.1 31.8 125.8L54.3 103C63.7 93.6 78.9 93.6 88.2 103L224.2 239C233.7 248.4 233.7 263.6 224.3 273z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/angle-right.js
// module id = null
// module chunks = 